import type { ILesson } from '../queries';
import { getOnboardingConfig } from 'features/Task/utils/getOnboardingConfig';

/**
 * Injects the onboarding lesson at the beginning of the lessons array
 * if the onboarding task is configured in Statsig
 * 
 * @param lessons - Array of lessons from the API
 * @param isOnboarded - Whether the user has completed onboarding (deprecated, defaults to false)
 * 
 * Note: The onboarding completion status will be determined by the backend
 * through progress messages during the conversation. The lesson will show
 * as incomplete until the backend marks it as complete.
 */
export function injectOnboardingLesson(
  lessons: ILesson[],
  isOnboarded: boolean = false
): ILesson[] {
  const maxPoints = 600;
  // Check if onboarding is configured
  const { taskId } = getOnboardingConfig();
  if (!taskId) {
    return lessons;
  }

  // Check if onboarding lesson already exists
  if (lessons.some(lesson => lesson.type === 'onboarding')) {
    return lessons;
  }

  // Create the onboarding lesson
  const onboardingLesson: ILesson = {
    id: '13cdc0f2-27bb-4aad-8e53-19aa1e1e4b72',
    name: 'Getting to Know You',
    description: 'Talk to Leya and get lessons tailored to your job and career.',
    emoji: '👋',
    type: 'onboarding',
    level: 'beginner',
    max_points: maxPoints,
    order: 0,
    tasks_completed: isOnboarded ? 1 : 0,
    tasks_total: 1,
    points_earned: isOnboarded ? maxPoints : 0,
    unlocked: true,
  };

  // Return lessons with onboarding at the beginning
  return [onboardingLesson, ...lessons];
}
